/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Prd_DescInputs */

const en_mk_tb_prd_desc = /** @type {(inputs: Mk_Tb_Prd_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review source requirements and coverage before creating tasks.`)
};

const id_mk_tb_prd_desc = /** @type {(inputs: Mk_Tb_Prd_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinjau kebutuhan dan cakupan sumber sebelum membuat tugas.`)
};

/**
* | output |
* | --- |
* | "Review source requirements and coverage before creating tasks." |
*
* @param {Mk_Tb_Prd_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_prd_desc = /** @type {((inputs?: Mk_Tb_Prd_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Prd_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_prd_desc(inputs)
	return en_mk_tb_prd_desc(inputs)
});